export const TODAY_REPORT_ID = 'today';
